export default __webpack_public_path__ + "static/media/dislike.627c5760.svg";